import { useCallback, useMemo, useState } from "react"

import {
  getRunsSelectionCount,
  type RunsTableSelection,
} from "../utils/runsTableState"

interface UseRunsTableSelectionParams {
  allItemsCount: number
}

export function useRunsTableSelection({
  allItemsCount,
}: UseRunsTableSelectionParams) {
  const [selectedKeys, setSelectedKeys] = useState<RunsTableSelection>(
    new Set([]),
  )
  const [runsToDelete, setRunsToDelete] = useState<string[]>([])
  const [isSelectMode, setIsSelectMode] = useState(false)

  const selectedCount = useMemo(
    () => getRunsSelectionCount(selectedKeys, allItemsCount),
    [selectedKeys, allItemsCount],
  )

  const clearSelectedKeys = useCallback(() => {
    setSelectedKeys(new Set([]))
  }, [])

  const handleExitSelectMode = useCallback(() => {
    setIsSelectMode(false)
    clearSelectedKeys()
  }, [clearSelectedKeys])

  const handleClearSelection = useCallback(() => {
    clearSelectedKeys()
    setIsSelectMode(false)
  }, [clearSelectedKeys])

  const handleToggleSelectMode = useCallback(() => {
    if (isSelectMode) {
      clearSelectedKeys()
    }

    setIsSelectMode(!isSelectMode)
  }, [clearSelectedKeys, isSelectMode])

  return {
    clearSelectedKeys,
    handleClearSelection,
    handleExitSelectMode,
    handleToggleSelectMode,
    isSelectMode,
    runsToDelete,
    selectedCount,
    selectedKeys,
    setRunsToDelete,
    setSelectedKeys,
  }
}
